import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { Header } from '@/components/docs/Header';
import { DocsSidebar } from '@/components/docs/Sidebar';

import LandingPage from '@/pages/LandingPage';
import IntroductionPage from '@/pages/docs/IntroductionPage';
import InstallationPage from '@/pages/docs/InstallationPage';
import QuickStartPage from '@/pages/docs/QuickStartPage';
import SkeletonPage from '@/pages/docs/SkeletonPage';
import FixturePage from '@/pages/docs/FixturePage';
import CLIPage from '@/pages/docs/CLIPage';
import ConfigPage from '@/pages/docs/ConfigPage';
import AuthPage from '@/pages/docs/AuthPage';
import PlaygroundPage from '@/pages/PlaygroundPage';

function DocsLayout() {
  return (
    <div className="flex">
      <DocsSidebar />
      <main className="flex-1 min-w-0 px-6 lg:px-12 py-10">
        <Outlet />
      </main>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-black text-white">
        <Header />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/docs" element={<DocsLayout />}>
            <Route index element={<IntroductionPage />} />
            <Route path="installation" element={<InstallationPage />} />
            <Route path="quick-start" element={<QuickStartPage />} />
            <Route path="skeleton" element={<SkeletonPage />} />
            <Route path="fixture" element={<FixturePage />} />
            <Route path="cli" element={<CLIPage />} />
            <Route path="config" element={<ConfigPage />} />
            <Route path="auth" element={<AuthPage />} />
          </Route>
          <Route path="/playground" element={<DocsLayout />}>
            <Route index element={<PlaygroundPage />} />
          </Route>
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
